<template>
  <div class="home">
    <el-header height="48px" class="zy-header">
      <template v-if="!superviseRole">
        <!-- <img class="logo" :src="require('@/assets/img/newlogo.png')" alt="" /> -->
        <div class="userStoreName">
          <span class="iconfont icon-zhiyunyaodianxitonglogo"></span>
          <span class="line"></span>
          <span class="sub_store_name">
            {{ renderName() }}
          </span>

          <!-- 会员标志模块 - 无缝循环滚动 -->
          <div class="member-badges" v-if="memberBadges.length">
            <div class="badges-container" :class="{ scrolling: memberBadges.length > 5 }">
              <!-- 原始标志 -->
              <span class="badge-text" v-for="(badge, index) in memberBadges" :key="`original-${index}`" :title="badge">
                {{ badge }}
              </span>
              <!-- 复制的标志用于无缝滚动 -->
              <template v-if="memberBadges.length > 5">
                <span class="badge-text" v-for="(badge, index) in memberBadges" :key="`copy-${index}`" :title="badge">
                  {{ badge }}
                </span>
              </template>
            </div>
          </div>
        </div>
      </template>

      <!-- <a class="float-right log-out" href="JavaScript:void(0)" @click="logOut">退出</a> -->

      <div class="user_handle">
        <el-dropdown size="medium" @command="handleCommand" trigger="click">
          <div class="usermessage">
            <img class="userPhoto" :src="userImg" alt="" />
            <span class="username">
              {{ company }}
            </span>
            <span>{{ roleList.join() }}</span>
            <img :src="require('@/assets/img/down_icon.png')" alt="" class="downicon" />
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="2" v-if="renderleaveSetting()">
              <div class="leaveSetting">
                <div class="leaveSetting_top">
                  <div class="text">离开设置</div>
                  <div class="switchBox">
                    <el-switch v-model="value" active-color="#4CD864" @change="switchChange"></el-switch>
                  </div>
                </div>
                <div class="leaveSetting_message">开启后不接受处方</div>
              </div>
            </el-dropdown-item>
            <el-dropdown-item command="3" v-if="isRendeUpdate()">
              <div class="leaveSetting operate update" @mouseenter="changeImg(2)" @mouseleave="changeImg(1)">
                <span>修改密码</span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item command="5" v-if="canBeUnbundled">
              <div class="leaveSetting operate el-icon">
                <i class="el-icon-phone-outline" style="margin-right: 10px"></i>
                <span>解绑手机号</span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item command="4" v-if="$checkPower('a')">
              <div class="leaveSetting operate agree" @mouseenter="changeImg(2)" @mouseleave="changeImg(1)">
                <span>协议中心</span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item command="1">
              <div class="leaveSetting operate quit" @mouseenter="changeImg(2)" @mouseleave="changeImg(1)">
                <span>退出登录</span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item v-if="!!$store.getters.isChain">
              <div class="company">{{ companyName }}</div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <div class="customer" v-if="customerInfo">
        <el-popover placement="bottom" width="0" trigger="click">
          <div class="customer-main">
            <img class="code-bg" src="@/assets/img/code-bg.png" alt="" />
            <img class="code" :src="customerInfo.codeUrl" alt="" />
            <p>
              {{ customerInfo.remark }}
            </p>
          </div>
          <div class="usermessage" slot="reference">
            <img class="userPhoto" src="@/assets/img/custom2.png" alt="" />
            <span class="username">客服咨询</span>
          </div>
        </el-popover>
      </div>

      <div class="tools" v-permission.not="'h,i,j'">
        <activityBannerNew />
        <div :class="render_tools_message()" @click="goMessageCenter()" v-if="!isSupervision">
          <!-- <img :src="require('@/assets/img/icon_news.png')" alt="" /> -->
          <span class="iconfont icon-xinxizhongxin message-icon">消息</span>
        </div>
        <el-dropdown size="medium" @command="handleMessageCommand" style="color: #fff" trigger="click" v-else>
          <div :class="render_tools_message()">
            <span class="iconfont icon-xinxizhongxin message-icon">消息</span>
          </div>
          <el-dropdown-menu slot="dropdown" class="messageDrop">
            <el-dropdown-item command="1">
              <div class="message">
                <span>智云问诊</span>
                <span class="dotView" v-if="messageCenterNotification"></span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item command="2">
              <div class="message">
                <span>数字药监</span>
                <span class="dotView" v-if="hasUnRead"></span>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="punch" v-if="punchOn" v-permission="'b'">
        <div class="btn" @click="punchInAndOut">
          <img :src="require('@/assets/img/icon_punch.png')" alt="" />
          {{ punchText }}
        </div>
      </div>
    </el-header>
  </div>
</template>

<script>
import { Header, Dropdown, DropdownMenu, DropdownItem, Switch, MessageBox } from 'element-ui';
import classnames from 'classnames';
import Vue from 'vue';
import Constant from '@/lib/constant';
import { hasPermission } from '@/util';
import { mapGetters, mapActions, mapState } from 'vuex';
import activityBannerNew from '@/components/activity/activityBannerNew';

import Fetch from '@/api';
import store from '@/store';
import { cmsReauest } from '@/api/http';

const baseRole = Constant.RoleList;
const quitImg1 = require('@/assets/img/icon_quit_nor.png');
const quitImg2 = require('@/assets/img/icon_quit_pre.png');
const userImg = require('@/assets/img/user_header.png');
const userImg2 = require('@/assets/img/icon_leave.png');

Vue.use(Header);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Switch);
export default {
  components: {
    activityBannerNew
  },
  name: 'homeHeader',
  props: {
    company: {}
  },
  data() {
    return {
      value: true,
      qiutImg: quitImg1,
      userImg,
      customerInfo: null

      // 会员标志mock数据 - 添加更多来测试滚动
      // memberBadges: ['VIP会员', '高级会员', '年费用户', '认证商家', '金牌会员', '钻石用户', '超级VIP']
    };
  },
  computed: {
    ...mapGetters(['serviceTypes']),
    memberBadges() {
      return this.serviceTypes;
    },
    userId() {
      return this.$store.getters.userId;
    },
    onlineStatus() {
      return this.$store.getters.onlineStatus;
    },
    storeList() {
      return this.$store.getters.storeList;
    },
    companyName() {
      return this.$store.getters.companyName;
    },
    storeAccoutnInfo() {
      return this.$store.getters.storeAccoutnInfo;
    },
    store_managerStoreInfo() {
      return this.$store.getters.store_managerStoreInfo;
    },
    roleList() {
      const { roleListFromBk = [] } = this.$store.state.global;
      return roleListFromBk.map(v => Constant.roleType[v.code]);
    },
    punchText() {
      const punchState = this.$store.getters.punchState;
      return punchState > 0 ? '下班打卡' : '上班打卡';
    },
    ...mapState('messageSupervision', ['hasUnRead']),
    ...mapGetters(['messageCenterNotification', 'superviseRole', 'punchOn', 'isSupervision']),
    canBeUnbundled() {
      return this.$checkPower('a') && this.$store.state.global.mobile;
    }
  },
  watch: {
    onlineStatus: {
      immediate: true,
      handler(v) {
        if (v == 0) {
          // 离线
          this.value = true;
          this.userImg = userImg2;
        } else {
          this.value = false;
          this.userImg = userImg;
        }
        // this.value = v == 1;
        // if (v == 1) {
        //   this.userImg = userImg2;
        // } else {
        //   this.userImg = userImg;
        // }
      }
    }
  },

  async mounted() {
    await this.getCustomerInfo();
  },
  methods: {
    ...mapActions('punch', ['punchInAndOut']),
    async getCustomerInfo() {
      this.customerInfo = await cmsReauest.get('wechat-customer-code-config');
    },
    isRendeUpdate() {
      // 公司负责人、店长、店员、药师、远程药师都有
      const roleList = [baseRole.a, baseRole.d, baseRole.b, baseRole.e, baseRole.f];
      return hasPermission(roleList);
    },

    renderName() {
      // 远程药师,大区负责人和公司负责人显示公司名，其余显示药店名
      if (this.$checkPower('a,b,c')) {
        return this.companyName;
      } else {
        return this.storeList && this.storeList.length > 0 ? this.storeList[0].name : '未知药店';
      }
    },
    async switchChange(v) {
      // 药师改变了状态
      let onlineStatus = v == true ? 0 : 1;
      try {
        let res = await Fetch.update_user_online_status({ onlineStatus });

        if (res.warnMsg) {
          this.value = !v; // 拦截操作
          this.$alert(res.warnMsg, '提示', {
            type: 'warn',
            confirmButtonText: '确定',
            callback: action => {}
          });
        } else {
          if (v == 0) {
            // 离线
            this.userImg = userImg;
          } else {
            this.userImg = userImg2;
          }
        }
      } catch (error) {
        this.value = !v; // 拦截操作
      }
    },

    renderleaveSetting() {
      // 渲染离开设置
      return this.onlineStatus == 1 || this.onlineStatus == 0;
    },
    render_tools_message() {
      const { messageCenterNotification } = this;
      // console.log('messageCenterNotification', messageCenterNotification);

      let cls = classnames({
        tools_message: true,
        tools_message_light: messageCenterNotification
      });
      return cls;
    },
    changeImg(tp) {
      if (tp == 1) {
        this.qiutImg = quitImg1;
      } else {
        this.qiutImg = quitImg2;
      }
    },
    goMessageCenter() {
      this.$router.push('/messageCenter');
    },
    handleCommand(command) {
      if (command == 1) {
        this.logOut();
      } else if (command == 3) {
        this.$router.push('/updatePwd');
      } else if (command == 4) {
        this.$router.push('/agreementList');
      } else if (command == 5) {
        this.$confirm(`是否确认将手机号${this.$store.state.global.mobile}与当前账号解绑？`, '提示')
          .then(res => {
            return Fetch.unbindCompanyManageMobile();
          })
          .then(() => {
            this.$message.success('解绑成功');
            this.$store.dispatch('permission/getInfo', { refresh: true });
          });
      }
    },
    handleMessageCommand(command) {
      if (command == 1) {
        this.$router.push('/messageCenter');
      } else if (command == 2) {
        this.$router.push('/messageCenterForSupervision');
      }
    },
    logOut() {
      Fetch.logOut().then(() => {
        // 用户退出后刷新清除所有数据 确保不会产生异常行为
        // this.$store.commit('permission/SET_ROLES', []);
        this.$router.replace({ name: 'Login' }, () => {
          location.reload();
        });

        // storage.remove(`PrescriptionList${this.userId}`);
        // storage.remove(`shopManagement${this.userId}`);
        // storage.remove(`staffManagement${this.userId}`);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.home {
  .zy-header {
    background: #1e8dff;
    background-image: url('./../../assets/img/new/header_bg.png');
    background-size: 1234px 48px;
    background-repeat: no-repeat;
    // background-origin: 0 0;
    height: 48px;
    line-height: 48px;
    color: #fff;
    font-size: 12px;

    &:after {
      content: '.';
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
    }

    .logo {
      width: 22px;
      float: left;
      margin-top: 14px;
      margin-right: 12px;
    }

    .name {
      float: left;
      font-size: 14px;
      color: #fff;
      line-height: 48px;
    }
  }

  .log-out {
    margin: 0 20px 0 24px;
    color: #fff !important;
    text-decoration: none;
  }
}

.qiut {
  display: flex;
  align-items: center;
  padding: 5px 0;

  &:hover {
    span {
      color: #1e8dff;
    }
  }

  img {
    display: block;
    width: 15px;
    margin-right: 10px;
  }

  span {
    font-size: 14px;
    color: #242424;
  }
}
</style>
<style lang="scss" scoped>
.leaveSetting {
  width: 148px;
  border-bottom: 1px solid #eee;

  .leaveSetting_top {
    overflow: hidden;

    .text {
      float: left;
      color: rgba(36, 36, 36, 1);
      font-size: 14px;
    }

    .switchBox {
      float: right;
    }
  }

  .leaveSetting_message {
    color: rgba(189, 189, 189, 1);
    font-size: 12px;
    position: relative;
    top: -6px;
  }

  &.operate {
    display: flex;
    align-items: center;
  }

  &.el-icon {
    &:before {
      display: none;
    }
  }

  &::before {
    content: '';
    display: inline-block;
    width: 16px;
    height: 18px;
    margin-right: 10px;
  }

  &.quit::before {
    background: url('../../assets/img/icon_quit_nor.png') no-repeat;
    background-size: cover;
  }

  &.update::before {
    background: url('../../assets/img/icon_edit.png') no-repeat;
    background-size: cover;
  }

  &.agree::before {
    background: url('../../assets/img/icon_agree.png') no-repeat;
    background-size: cover;
  }

  &:hover {
    color: #1e8dff;

    &.update::before {
      background: url('../../assets/img/icon_edit_01.png') no-repeat;
      background-size: cover;
    }

    &.quit::before {
      background: url('../../assets/img/icon_quit_pre.png') no-repeat;
      background-size: cover;
    }

    &.agree::before {
      background: url('../../assets/img/icon_agree_01.png') no-repeat;
      background-size: cover;
    }
  }
}

.userStoreName {
  float: left;
  display: flex;
  align-items: center;

  span {
    // font-weight: bold;
    // line-height: 20px;
    font-size: 14px;
    color: #fff;

    &.iconfont {
      font-size: 24px;
    }

    &.line {
      display: inline-block;
      margin: 0 12px;
      width: 1px;
      height: 16px;
      background: #ffffff;
      border-radius: 2px;
      opacity: 0.35;
      position: relative;
      top: 1px;
    }

    &.sub_store_name {
      position: relative;
      top: 2px;
    }
  }
}

.usermessage {
  cursor: pointer;
  display: block;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 12px;

  .userPhoto {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    margin-right: 8px;
  }

  .username {
    line-height: 48px;
    color: #fff;
    font-size: 12px;
    margin-right: 20px;
  }

  .downicon {
    margin-left: 5px;
  }
}

.user_handle {
  float: right;
  height: 100%;

  &:hover {
    outline: 0;
  }
}

.customer {
  float: right;
  height: 100%;

  &:hover {
    outline: 0;
  }
}

.customer-main {
  position: relative;

  .code {
    margin: 4px;

    width: 116px;
  }
  .code-bg {
    top: 0px;
    left: 0px;
    position: absolute;
    width: 124px;
  }
  p {
    font-size: 12px;
    text-align: center;
    color: #262626;
    margin: 0px 4px 0px;
  }
}

.messageDrop {
  top: 35px !important;

  /deep/.el-dropdown-menu__item {
    padding: 0 4px;
  }

  .message {
    padding: 0 8px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.04);

    // box-shadow: 0px 3px 5px 0px rgba(0,0,0,0.15);
    .dotView {
      display: inline-block;
      width: 8px;
      border-radius: 8px;
      margin-left: 16px;
      position: relative;
      top: -2px;
      height: 8px;
      background: #fa4b4b;
      // box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.15);
      text-align: right;
    }
  }
}

.tools {
  float: right;
  margin-right: 32px;
  display: flex;
  height: 100%;

  .basetools {
    cursor: pointer;
  }

  .tools_message {
    @extend .basetools;
    margin-top: 17px;

    // img {
    //   display: block;
    //   width: 18px;
    // }
    .message-icon {
      font-size: 14px;
      right: 4px;
      position: relative;
      top: -17px;

      &::before {
        position: relative;

        font-size: 18px;
        top: 2px;
      }
    }
  }

  .tools_message_light {
    position: relative;

    &:after {
      content: '';
      width: 6px;
      height: 6px;
      display: block;
      border-radius: 50%;
      position: absolute;
      background: #e0514c;
      border: 1px solid #fff;
      top: -4px;
      right: -3px;
    }
  }
}

.punch {
  float: right;
  display: flex;
  align-items: center;
  margin-right: 29px;
  height: 100%;

  .btn {
    padding: 0 12px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    line-height: 24px;
    background-color: #3a9e4e;
    cursor: pointer;

    img {
      width: 16px;
      height: 16px;
      vertical-align: -4px;
    }
  }
}

.company {
  padding: 8px 0;
  max-width: 182px;
  font-size: 12px;
  line-height: 16px;
  color: #bdbdbd;
  text-align: center;
  word-break: break-all;
}

// 会员标志模块样式 - 无缝循环滚动
.member-badges {
  margin-left: 8px;
  max-width: 200px;
  overflow: hidden;
  position: relative;

  .badges-container {
    display: flex;
    align-items: center;
    gap: 4px;

    &.scrolling {
      animation: seamless-scroll 20s linear infinite;
      width: max-content;
    }

    .badge-text {
      padding: 1px 4px;
      border-radius: 2px;
      font-size: 10px;
      white-space: nowrap;
      line-height: 1.2;
      flex-shrink: 0;
      background: linear-gradient(45deg, #ffd700 0%, #ffc107 50%, #ffb300 100%);
      color: #8b4513;
      border: 1px solid #ffd700;
      border-radius: 6px;
      font-weight: 700;
      box-shadow: 0 2px 8px rgba(255, 215, 0, 0.3);
    }
  }

  // // 渐变遮罩效果
  // &::before,
  // &::after {
  //   content: '';
  //   position: absolute;
  //   top: 0;
  //   bottom: 0;
  //   width: 10px;
  //   z-index: 1;
  //   pointer-events: none;
  // }

  // &::before {
  //   left: 0;
  //   background: linear-gradient(to right, rgba(255, 255, 255, 1), transparent);
  // }

  // &::after {
  //   right: 0;
  //   background: linear-gradient(to left, rgba(255, 255, 255, 1), transparent);
  // }
}

// 无缝循环滚动动画
@keyframes seamless-scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%); // 移动到一半位置，因为内容复制了一份
  }
}

// 响应式处理
@media (max-width: 768px) {
  .member-badges {
    max-width: 150px;

    .badges-container.scrolling {
      animation-duration: 15s;
    }
  }
}
</style>
